export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAILURE = 'SEARCH_FAILURE';
export const FIRST_REQUEST_SUCCESS = 'FIRST_REQUEST_SUCCESS';

export const SET_FILTER = 'SET_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const CLICK_PAGINATION = 'CLICK_PAGINATION';
export const SET_QUERY = 'SET_QUERY';

export const SINGLE_REQUEST = 'SINGLE_REQUEST';
export const SINGLE_SUCCESS = 'SINGLE_SUCCESS';
export const SINGLE_FAILURE = 'SINGLE_FAILURE';
